import { render, staticRenderFns } from "./DelfiForm.vue?vue&type=template&id=a25531e6"
import script from "./DelfiForm.vue?vue&type=script&lang=ts"
export * from "./DelfiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports